














































import { Form, FormItem, Input, Button } from 'element-ui'
import { Component, Vue, Prop } from 'vue-property-decorator'

import Review from '@/models/review'

@Component({
  components: {
    [Input.name]: Input,
    [Form.name]: Form,
    [FormItem.name]: FormItem,
    [Button.name]: Button,
  },
})
export default class CustomerReview extends Vue {
  @Prop() review!: Review

  get groupSize(): string {
    switch (this.review.groupSize) {
      case 'Solo':
        return 'Solo Traveler'
      case 'Friend/s':
        return 'Traveling with friends'
      case 'Couple':
        return 'Traveling with couple'
      case 'Family':
        return 'Traveling with family'
      default:
        return ''
    }
  }
}
